export default __webpack_public_path__ + "static/media/mapping-disabled.e7dedef8.svg";